import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/lib/providers";

const LINKS = [
  ["/", "الرئيسية"],
  ["/courses", "الكورسات"],
  ["/about", "عن الأكاديمية"],
  ["/faq", "الأسئلة الشائعة"],
  ["/contact", "تواصل معنا"],
];

export const Logo = ({ small, onDark }) => (
  <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
    <img src="/logo.png" alt="خرابيش أكاديمي" className="w-11 h-11 rounded-xl kh-wiggle" />
    {!small && (
      <span className="leading-none">
        <span className={`block font-display text-2xl ${onDark ? "text-white" : "text-ink"}`}>خرابيش</span>
        <span className={`block text-[10px] tracking-[0.3em] ${onDark ? "text-purple-300" : "text-brand"}`}>KHARABEESH ACADEMY</span>
      </span>
    )}
  </Link>
);

const UserActions = ({ onNav }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (!user)
    return (
      <>
        <Link to="/login" onClick={onNav} data-testid="nav-login-btn" className="px-4 py-2 rounded-full text-sm text-ink hover:text-brand hover:bg-purple-50 transition-colors">دخول</Link>
        <Link to="/register" onClick={onNav} data-testid="nav-register-btn" className="btn-pop btn-primary px-5 py-2 rounded-full text-sm font-semibold">اعمل حسابك مجانًا</Link>
      </>
    );
  return (
    <>
      <Link to="/dashboard" onClick={onNav} data-testid="nav-dashboard-btn" className="btn-pop btn-primary flex items-center gap-1 px-5 py-2 rounded-full text-sm font-semibold"><LayoutDashboard size={16} />لوحة التحكم</Link>
      <button data-testid="nav-logout-btn" onClick={async () => { await logout(); onNav?.(); nav("/"); }} className="p-2 rounded-full text-soft hover:text-brand hover:bg-purple-50" aria-label="تسجيل الخروج"><LogOut size={18} /></button>
    </>
  );
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <Logo />
        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map(([to, label]) => (
            <NavLink key={to} to={to} end data-testid={`nav-link-${to.replace("/", "") || "home"}`}
              className={({ isActive }) => `px-3 py-2 rounded-full text-sm transition-colors ${isActive ? "text-brand bg-purple-50 font-semibold" : "text-soft hover:text-brand"}`}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-2"><UserActions /></div>
        <button className="lg:hidden p-2 text-ink" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="القائمة">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-line bg-white px-4 py-4 space-y-1" data-testid="nav-mobile-menu">
          {LINKS.map(([to, label]) => (
            <Link key={to} to={to} onClick={() => setOpen(false)} className="block px-3 py-3 rounded-xl text-ink hover:bg-purple-50">{label}</Link>
          ))}
          <div className="flex flex-wrap items-center gap-2 pt-3"><UserActions onNav={() => setOpen(false)} /></div>
        </div>
      )}
    </header>
  );
}
